/**
 * Phone validation utilities for mobile number inputs.
 * Validates 10-15 digits only; no letters or other text allowed.
 */

/** Strip to digits only for validation. */
export function normalizePhone(value: string): string {
  return (value || "").replace(/\D/g, "");
}

/**
 * Filter input to allow only valid mobile number chars: digits, optional leading +, spaces, dashes.
 * Use in onChange to prevent text/letters from being entered.
 */
export function formatPhoneInput(value: string): string {
  const v = (value || "").trimStart();
  let result = "";
  let seenPlus = false;
  for (let i = 0; i < v.length; i++) {
    const c = v[i];
    if (c === "+" && !seenPlus && result === "") {
      result += c;
      seenPlus = true;
    } else if (/\d/.test(c)) {
      result += c;
    } else if (c === " " || c === "-") {
      result += c;
    }
    // skip letters and any other chars
  }
  return result;
}

/** Check if value is a valid mobile number (10-15 digits). */
export function isValidMobileNumber(value: string): boolean {
  const digits = normalizePhone(value || "");
  return digits.length >= 10 && digits.length <= 15;
}

/**
 * Returns an error message if invalid, or null if valid.
 */
export function validateMobileNumber(value: string): string | null {
  const trimmed = (value || "").trim();
  if (!trimmed) return "Phone number is required";
  const digits = normalizePhone(trimmed);
  if (digits.length < 10) return "Enter a valid mobile number (at least 10 digits, numbers only)";
  if (digits.length > 15) return "Enter a valid mobile number (max 15 digits)";
  return null;
}
